import React from 'react'
import { Modal } from 'react-bootstrap';
import { Errors } from '../../../Component/Error';
import useDragDrop from '../../../Hooks/useDrag&Drop';
import { AiOutlineCloudUpload } from 'react-icons/ai';
import PdfImage from '../../../Assets/Images/home/pdf.svg';
import { FilePathName } from '../../../Context/api';
import useDeleteFile from '../../../Hooks/useDeleteFile';
const CreateTestReport = ({ methods, data }) => {
    const { openModal, Url, UploadReportType, CustomButton } = data
    const { handleClosedModal, addReport, uploadPdf, setUrl } = methods
    const { handleDragEnter, handleDragLeave, handleDragOver, handleDrop } = useDragDrop()
    const { deleteFileFun } = useDeleteFile()

    return (
        <>
            <Modal show={openModal?.createTestReport} centered>
                <Modal.Body>
                    <div className="d-flex justify-content-between">
                        <p className="modal-title mb-0 page_name">Create Report</p>
                    </div>
                    <div className="modal-body  cus-i">
                        <div className="row">
                            <div className="col-sm-12  py-3 " >
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="row">
                                            <div className="col-lg-3">
                                                <label className="form-label mb-0">Title<span className='Star_Mark'>*</span></label>
                                            </div>
                                            <div className="col-lg-9">
                                                <input type="text" maxLength={50} className="form-control"
                                                    value={addReport.values.title}
                                                    onChange={(e) => addReport.setFieldValue(`title`, e.target.value)}
                                                />
                                                <Errors formikfun={addReport} name={"title"} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-12" >
                                <div className="row">
                                    <div className="col-lg-3">
                                        <label className="form-label mb-0">Description<span className='Star_Mark'>*</span></label>
                                    </div>
                                    <div className="col-lg-9">
                                        <textarea className="form-control"
                                            value={addReport.values.description}
                                            onChange={(e) => addReport.setFieldValue("description", e.target.value)}
                                        />
                                        <Errors formikfun={addReport} name={"description"} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-12  py-4 " >
                                <div className="bodrerer col w-100" style={{ border: `${!Url ? "2px dashed #aaaaaa" : "none"}`, width: "100%", maxWidth: "100%" }}
                                    onDragEnter={handleDragEnter}
                                    onDragLeave={handleDragLeave}
                                    onDragOver={handleDragOver}
                                    onDrop={(e) => handleDrop(e, uploadPdf)}
                                >
                                    <label htmlFor="inputTag">
                                        <AiOutlineCloudUpload className="fs-4" />
                                        {Url && <img src={UploadReportType === "application/pdf" ? PdfImage : FilePathName + Url} alt="" />}
                                        <input id="inputTag" type="file" name="file" onChange={(e) => { uploadPdf(e.target.files[0]) }} />
                                        <br style={{ fontSize: "13px" }} />
                                        {
                                            !Url && <p className="mb-0">Drag file(s) here or <span>click to upload</span></p>
                                        }

                                        <br />
                                    </label>
                                </div>
                                {
                                    Url && <p className=" m-0 ms-3 mt-2 all_icons_color text-center text-danger" style={{ cursor: 'pointer', }} onClick={() => deleteFileFun(setUrl, { fileName: Url, type: "TESTREPORT", id: null }, true)}>Delete</p>
                                }
                            </div>
                            <div className="col-sm-12 text-center mt-3">
                                <CustomButton variant="outlined" className="me-2" onClick={() => { handleClosedModal("createTestReport"); addReport.resetForm() }} >Cancel</CustomButton>
                                <CustomButton variant="contained" className="" onClick={addReport.handleSubmit} >submit</CustomButton>
                            </div>
                        </div>
                    </div>

                </Modal.Body>
            </Modal>
        </>
    )
}

export default CreateTestReport
